import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../Tooltip';
import HotjarMasked from '../HotjarMasked';
import noop from '../../utils/noop';
import { getMessage } from '@a0/support-center-common/lib/getMessage';

import './styles.css';

class Check extends Component {
  constructor(props) {
    super(props);
    this.state = { showDetails: false };
    this.toggleDetails = this.toggleDetails.bind(this);
    this.trackExternalClick = this.trackExternalClick.bind(this);
  }

  toggleDetails(event) {
    const { Metrics, title } = this.props;
    const { showDetails } = this.state;
    if (event) {
      event.preventDefault();
    }

    if (!showDetails) {
      Metrics.track('click:sc:tenant:productioncheck:details', {
        value: title
      });
    }

    this.setState({ showDetails: !showDetails });
  }
  

  trackExternalClick(name, url) {
    return () => {
      const { Metrics, title } = this.props;
      Metrics.track(`click:sc:tenant:productioncheck:${name}`, {
        value: title
      });
    };
  }

  render() {
    const {
      title,
      description,
      checkFailedText,
      url,
      action_url, 
      client_url,
      doc_url,
      result,
      details,
      type,
      hasResult,
      runned,
      clientListTotal,
      applies_to
    } = this.props;
    
    const sortedDetails = [...details];
    sortedDetails.sort((detailX, detailY) => {return ('' + detailX.clientName ||'').localeCompare(detailY.clientName || '');});
    return (
      <li
        className={classNames('check', {
          hidden: runned && type !== 'text' && !hasResult
        })}
      >
        <div className="row">
          <div className="col-sm-1">
            {result &&
            (result === 'fail' || result === 'error') && (
              <Tooltip
                title={
                  result === 'fail' ? (
                    'The check has been failed'
                  ) : (
                    'The check has an error'
                  )
                }
              >
                <i className="check-icon check-icon--fail icon-budicon-501" />
              </Tooltip>
            )}
            {type === 'text' ? (
              <Tooltip title="Guidance">
                <i className="check-icon check-icon--info icon-budicon-724" />
              </Tooltip>
            ) : (
              ''
            )}
            {!result &&
            type !== 'text' && (
              <i className="check-icon check-icon--info icon-budicon-469" />
            )}
          </div>
          <div className="col-sm-11">
            <div
              className={`check-header ${runned && type !== 'text' && !hasResult
                ? 'check-header--disabled'
                : ''}`}
            >
              <strong className="check-title">{title}</strong>
              {runned &&
              type !== 'text' &&
              !hasResult && (
                <strong className="check-title">
                  <span className="check-pipe">|</span>Coming soon
                </strong>
              )}
              <p className="check-description">
                {
                  (checkFailedText && (result === 'fail' || result === 'error')) 
                    ? `${checkFailedText} ${description}` 
                    : description
                }
              </p>
              {details &&
              details.length >= 1 && (
                <div className="check-error">
                  <span className="check-error-clients">
                    <i className="check-icon--fail icon-budicon-501" />{' '}
                    {applies_to === 'client' ? (
                      `${[...new Set(details.map(detail => detail.clientName))]
                        .length}/${clientListTotal} ${getMessage(
                        'CLIENTS_FAILED'
                      )}`
                    ) : (
                      'Failed.'
                    )}
                  </span>{' '}
                  <span>
                    <a
                      className="check-link check-link--show"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="#"
                      onClick={this.toggleDetails}
                    >
                      {this.state.showDetails ? 'Hide details' : 'Show details'}
                    </a>
                  </span>
                  {this.state.showDetails && (
                    <div className="check-error-details">
                      <h2>ERROR DETAILS</h2>
                      <ul>
                        {sortedDetails.map(({ actionName, clientName, message, actionId, clientId, connectionId }) => (
                          <li key={`${clientName || ''}${message}`}>
                            <HotjarMasked>
                              {clientName ? (
                                <strong>{clientName}:</strong>
                              ) : actionName ? actionName && (
                                <strong>{actionName}:</strong>
                              ) :null}{' '}
                              <span>{message}</span>
                              {client_url && (
                                <span>
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={client_url.replace(
                                      '{client_id}',
                                      clientId
                                    ).replace(
                                      '{connection_id}',
                                      connectionId
                                    )}
                                    onClick={this.trackExternalClick(
                                      'manage',
                                      client_url
                                    )}
                                  >
                                    {' '}
                                    Configure App
                                  </a>
                                </span>
                              )}
                               {action_url && (
                                <span>
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={action_url.replace(
                                      '{action_id}',
                                      actionId
                                    )}
                                    onClick={this.trackExternalClick(
                                      'manage',
                                      action_url
                                    )}
                                  >
                                    {' '}
                                    Configure Action
                                  </a>
                                </span>
                              )}
                            </HotjarMasked>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
              <div className="check-links">
                {doc_url && (
                  <a
                    className="check-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={doc_url}
                    onClick={this.trackExternalClick('docs', doc_url)}
                  >
                    Documentation
                  </a>
                )}
                {doc_url && url && <span className="check-pipe">|</span>}
                {url && (
                  <Tooltip title="Configure">
                    <a
                      className="check-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={url}
                      onClick={this.trackExternalClick('manage', url)}
                    >
                      Configure
                    </a>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

Check.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  checkFailedText: PropTypes.string,
  url: PropTypes.string,
  doc_url: PropTypes.string,
  action_url:PropTypes.string,
  client_url: PropTypes.string,
  result: PropTypes.string,
  details: PropTypes.array,
  type: PropTypes.string,
  hasResult: PropTypes.bool,
  runned: PropTypes.bool,
  clientListTotal: PropTypes.number,
  Metrics: PropTypes.object,
  applies_to: PropTypes.string
};

Check.defaultProps = {
  details: [],
  Metrics: { track: noop }
};

export default Check;
